import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2'
import moment from "moment";

import { Pagination } from '../../Res/Pagination';
import { ReqSystemAccountList } from '../../../../item/ItemAccount';
import { ContentBox } from '../../Content/ContentBox';
import { AddButton, SearchButton, EnableBadge, DisableBadge, CancelButton, SubmitButton } from '../../Res/BaseButton';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { api_getSystemAccountList } from '../../../../api/apiAccount';
import { SingleInput } from '../../Res/BaseInput';

export function AccountList({}) {
  const [accountList, setAccountList] = useState([])
  const [page, setPage] = useState(1)
  const [limit] = useState(10)
  const [count, setCount] = useState(0)
  const [disableCount, setDisableCount] = useState(0)
  const [enableCount, setEnableCount] = useState(0)

  const [mobile, setMobile] = useState("")
  const [nickName, setNickName] = useState("")
  const [isDisable, setIsDisable] = useState(-1)

  var title = '帳號列表'
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">
          <EnableBadge count={enableCount} />
          <DisableBadge count={disableCount} />
          <AddButton name={"新增"} action={toAdd} />
        </div>
      </div>
      <div className="row m-b-sm">
      </div>
      <AccountListBox accountList={accountList}  count={count} page={page} sp={toSearchPage} limit={limit} />
    </>




  useEffect(() => {
    if (accountList.length === 0) {
      getAccountList(page)
    }
  }, [])
  

  function getAccountList(page) {
    console.log("getManagerList")
    var start = (page - 1) * limit;
    var mReqSystemAccountList = new ReqSystemAccountList({ start, limit, mobile, nickName, isDisable })
    api_getSystemAccountList({
      mReqSystemAccountList,
      success: (obj) => {
        console.log(obj)
        setAccountList(obj.list)
        setCount(obj.count)
        setDisableCount(obj.disableCount)
        setEnableCount(obj.enableCount)
      },
      failure: (err) => {
        console.log(err)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function toAdd() {
    window.location.assign("/AccountAdd");
  }

  function toCelar(){
    setMobile("")
    setNickName("")
    setIsDisable(-1)
  }

  function toSearchPage(val){
    console.log(val)
    setPage(val)
    getAccountList(val)
  }

  function toSearch() {
    setPage(1)
    getAccountList(1)
  }

  return (
    <>
    
      <ManagerListSearch m={mobile} sm={setMobile} n={nickName} sn={setNickName} s={isDisable} ss={setIsDisable} toC={toCelar} toS={toSearch} />
     
      <ContentBox title={title} content={content} hasDrawer={true} />
      <SystemPromptInput />
      {/**
      <Precautions precautionsInfo={precautionsInfo} hasDrawer={true} defaultHideDrawer={false} />
       */}
    </>
  )
}

function ManagerListSearch({m, sm, n, sn, s, ss, toC, toS}) {
  const [mobile, setMobile] = useState(m)
  const [nickName, setNickName] = useState(n)
  const [status, setStatus] = useState(s)

  useEffect(()=>{
    if(m !== mobile){
      setMobile(m)
    }
  },[m])

  useEffect(()=>{
    if(n !== nickName){
      setNickName(n)
    }
  },[n])

  useEffect(()=>{
    if(s !== status){
      setStatus(s)
    }
  },[s])

  var content =
  <>
    <div className="row">
      <SingleInput title={"以帳號搜尋"} val={mobile} action={sm} size={4} />
      <SingleInput title={"以暱稱搜尋"} val={nickName} action={sn} size={4} />
      <div className="col-sm-4">
        <p>
          狀態
          </p>
        <select className="select2_demo_1 form-control" value={status} onChange={e=>ss(e.target.value)}>
          <option value="-1">全部</option>
          <option value="0">啟用</option>
          <option value="1">停用</option>
        </select>
      </div>

    </div>
      <div className="row m-t-sm m-t-sm">
        <div className="col-sm-4 col-sm-offset-5">
          <CancelButton name={"清除"} action={toC} />
          <SearchButton action={toS} />
        </div>
      </div>
  </>
  return (
    <ContentBox hasTitle={false} content={content} hasDrawer={true} />
  )
}

function AccountListBox({ accountList, count, page, sp, limit }) {
  const [mAccountList, setAccountList] = useState([])
  const [mPage, setPage] = useState(1)
  const [mLimit] = useState(limit)
  const [mCount, setCount] = useState(0)

  useEffect(() => {
    if (accountList !== undefined && mAccountList !== accountList) {
      setAccountList(accountList)
      setPage(page)
    }

    if(count !== mCount){
      setCount(count)
    }
  })

  function sPage(p) {
    console.log("pagechange page: " + page + " p: "+p)
    if (p !== page) {
      sp(p)
      setPage(p)
    }
  }

  if (mAccountList.length === 0) {
    return (<></>)
  } else {
    //console.log(managerList)
    return (
      <div id="editable_wrapper" className="form-inline dt-bootstrap">
        <div className="row">
          <div className="col-sm-12">
            <table className="table table-striped table-bordered table-hover  dataTable">
              <thead>
                <tr role="row">
                  <th className="text-center sorting col-sm-4">帳號</th>
                  <th className="text-center sorting col-sm-4">暱稱</th>
                  <th className="text-center sorting col-sm-4">狀態</th>
                </tr>
              </thead>
              <tbody>
                {
                  mAccountList.map((account) => (
                    <AccountBox key={account.mobile} account={account} />
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
        {
          mCount === 0 ? <></> : <Pagination p={mPage} l={mLimit} c={mCount} sp={sPage} />
        }
      </div>
    )
  }

}

function AccountBox({ account }) {
  const [mAccount, setAccount] = useState(account)

  if (account !== mAccount) {
    setAccount(account)
  }

  function toAccountDetail() {
    window.location.assign("/AccountDetail/" + account.accountId);
  }

  var creatAt = moment(new Date(account.creatAt)).format("YYYY-MM-DD HH:mm:ss");
  var avatar = <img className="img-circle" src="/img/a3.jpg" alt="User profile" />
  if (account.avatar !== "") {
    avatar = <img className="img-circle" src={account.avatar} alt="User profile" />
  }
  var status = "<></>";

  if (account.isDisable === 1) {
    status = <span className="text-danger">停用</span>
  } else {
    status = <span className="text-info">啟用</span>
  }

  return (
    <tr role="row">
      <td className="text-center"><a href="#A" onClick={toAccountDetail}>{account.mobile}</a></td>
      <td className="text-center">{account.nickName}</td>
      <td className="text-center"><span>{status}</span></td>
    </tr>
  )
}
